import React from 'react'
import { Link } from 'react-router-dom'
import { Settings } from '../index'
import "./Header.css"

const Header = (props) => {
    const [visible, isVisible] = React.useState(false);
    const togglePanel = () => {
        isVisible(visible => !visible)
    }

    return (
        <>
            <div className="header">

                {/* TODO: Refactor -- Signature Component */}
                <div className="header__title">
                    <span><b><Link className="logo" to='/'>Ronnie,</Link></b></span>
                    <span className="logo_subtitle">Fullstack dev.</span>
                </div>

                {/* TODO: Refactor -- Social Component */}
                <div className="header__social header__social--bold">
                    <span>LinkedIn</span>
                    <span>GitHub</span>
                    <span>blogspace</span>
                </div>

                <div className="header__settings">
                    <span onClick={togglePanel} className={`material-icons icon--large ${visible ? 'forward' : 'reverse' }`}>
                    settings
                    </span>
                </div>
            </div>

            <div className="settings" style={{display: visible ? 'flex' : 'none'}}>
                <Settings {...props} />
            </div>
        </>
    )
}

export default Header